
const Footer = () => {
  return (
    <footer className="bg-[#1C1C1C] text-white py-12">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-[#C2A97A] rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-lg">嚴</span>
              </div>
              <h3 className="text-xl font-bold">嚴前總統家淦先生紀念協會</h3>
            </div>
            <p className="text-gray-300 leading-relaxed">
              秉持嚴前總統家淦先生為國為民的精神，推動財經建設、促進工商繁榮，深化文化與學術交流，守護文化資產，惠澤社會。
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">聯絡資訊</h4>
            <div className="space-y-2 text-gray-300">
              <div className="flex items-center space-x-2">
                <i className="ri-mail-line w-5 h-5 flex items-center justify-center"></i>
                <span>ckyen.cs@gmail.com</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-map-pin-line w-5 h-5 flex items-center justify-center"></i>
                <span>臺北市中正區重慶南路二段2.4號</span>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">相關連結</h4>
            <div className="space-y-2">
              <a href="#about" className="block text-gray-300 hover:text-[#C2A97A] transition-colors cursor-pointer">協會介紹</a>
              <a href="#events" className="block text-gray-300 hover:text-[#C2A97A] transition-colors cursor-pointer">紀念活動</a>
              <a href="#biography" className="block text-gray-300 hover:text-[#C2A97A] transition-colors cursor-pointer">生平事蹟</a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
          <p>
            © 2025 嚴前總統家淦先生紀念協會 | 文化部指導 | 
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="hover:text-[#C2A97A] transition-colors cursor-pointer ml-2"
            >
              Website Builder
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
